import { Controller } from "@hotwired/stimulus"
import { post } from '@rails/request.js'
import { debounce } from "lodash"

export default class extends Controller {
  static targets = ['template', 'destination', 'count']

  rules = {}
  filter_id = undefined

  connect() {
    this.debounce = debounce(() => { this.refresh() }, 300)
    this.debounce()
  }

  handle({ detail, target }) {

    if (detail.rules.length == 0) {
      delete this.rules[detail.unique_id]
      target.remove()
    } else {
      this.rules[detail.unique_id] = detail.rules
    }

    if (Object.values(this.rules).length == 0) {
      console.log("no rules")
      this.destinationTarget.innerHTML = ""
      this.duplicate({ target: undefined })
    }

    this.debounce()
  }

  duplicate({ target }) {
    target?.remove()
    this.destinationTarget.insertAdjacentHTML("beforeend", this.templateTarget.innerHTML)
  }

  refresh() {
    post('/app/filters.json', { body: JSON.stringify({ filter: { rules: Object.values(this.rules) } }) })
      .then(async response => {
        if (response.ok) {
          const json = await response.json
          this.filter_id = json.filter.id
          this.countTarget.innerText = json.meta.total_count
        } else {
          console.error("Error updating filter")
        }
      })
  }

  select() {
    this.dispatch('selected', {
      detail: {
        rules: Object.values(this.rules),
        filter_id: this.filter_id
      }
    })
  }

  clear() {
    this.rules = {}
    this.destinationTarget.innerHTML = ""
    this.duplicate({ target: undefined })
    this.debounce()
  }
}
